// Keep first: TypeScript ignores a triple-slash directive that follows any
// statement, so an import above this line silently un-declares `$localize`.
/// <reference types="@angular/localize" />

import { provideZonelessChangeDetection } from '@angular/core';
import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { AppComponent } from './app/app.component';

// Zoneless: there is no zone.js in `angular.json`'s `polyfills` either, and the two
// have to stay in step. `provideZonelessChangeDetection()` logs NG0914 at startup if
// zone.js is loaded anyway, so a regression is visible in the console rather than
// silent. Note `polyfills` must remain present as `[]` — deleting the key makes the
// unit-test builder load zone.js dynamically and the specs drift back to zone CD.
bootstrapApplication(AppComponent, {
  ...appConfig,
  providers: [provideZonelessChangeDetection(), ...appConfig.providers],
}).catch((err) => console.error(err));
